import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: 'https://2a2ba39d3ae5278ea17517a935d50451@o4508400682663936.ingest.de.sentry.io/4508400684040272',

  // Adjust this value in production, or use tracesSampler for finer control
  tracesSampleRate: process.env.NODE_ENV === 'production' ? (process.env.VERCEL_ENV === 'production' ? 0.1 : 1.0) : 0.0,

  // Disable debug to prevent console logs
  debug: false,

  // Improved source map handling
  attachStacktrace: true,

  // For better error tracking
  normalizeDepth: 10,

  // Get the actual release version from Vercel
  release: process.env.VERCEL_GIT_COMMIT_SHA || 'dev',

  // Set environment based on Vercel
  environment: process.env.VERCEL_ENV || process.env.NODE_ENV || 'development',

  // Enable default PII for better error context
  sendDefaultPii: true,

  // ReplayIntegration for better session tracking
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  // Performance Monitoring
  replaysSessionSampleRate: 0.1, // Sample rate for performance monitoring
  replaysOnErrorSampleRate: 1.0, // Always capture sessions with errors
})
